import { render } from "./PlaceDescription.vue?vue&type=template&id=4278692d&scoped=true"
import script from "./PlaceDescription.vue?vue&type=script&lang=js"
export * from "./PlaceDescription.vue?vue&type=script&lang=js"

import "./PlaceDescription.vue?vue&type=style&index=0&id=4278692d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4278692d"]])

export default __exports__